import { HandleAuthError } from '../universal/Alert';
import axios from 'axios';
import apiClient  from '../../apiClient';

export const SelectAllFromTable = (table, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        { "function_to_execute": "Select_All_From_Table", "table": table }
    ).then(({ data }) => {
        action(data)
    }).catch(function(error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            alert(error?.response?.data)    
        }
    });
}

export const SelectGenericFromTable = (query, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        //"https://us-central1-airy-semiotics-297902.cloudfunctions.net/cloud-sql-interface",
        { "function_to_execute": "Select_Data", "query": query }
    ).then(({ data }) => {
        action(data)
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error)
            console.log(error?.response?.data)
            //alert(error?.response?.data)
        }
    });
}
export const SelectRowFromTable = (query, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        //"https://us-central1-airy-semiotics-297902.cloudfunctions.net/cloud-sql-interface",
        { "function_to_execute": "Select_Data", "query": query }
    ).then(({ data }) => {
        action(data[0])
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            //alert(error?.response?.data)
        }
    });
}
export const SelectColumnFromTableRow = (query, column, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        //"https://us-central1-airy-semiotics-297902.cloudfunctions.net/cloud-sql-interface",
        { "function_to_execute": "Select_Data", "query": query }
    ).then(({ data }) => {
        if (data.length === 0) { 
            action(undefined); return;
        }
        action(data[0][column])
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            //alert(error?.response?.data)
        }
    });
}

export const GetDensityNetworkConfigFile = (density_network_config_id, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        { "function_to_execute": "Pull_Density_Network_Config_File", "density_network_config_id": density_network_config_id }
    ).then(({ data }) => {
        action(data)
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            //alert(error?.response?.data)
        }
    });
}


export const GetPersisterConfigFile = (persister_config_id, action) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        { "function_to_execute": "Pull_Persister_Config_File", "persister_config_id": persister_config_id }
    ).then(({ data }) => {
        action(data)
    }).catch(function (error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            //alert(error?.response?.data)
        }
    });
}


export const ReturnGenericFromTable = (query, dispatch) => {
    apiClient.post(
        "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
        { "function_to_execute": "Select_Generic_From_Table", "query": query }
    ).then(({ data }) => {
        return data
    }).catch(function(error) {
        if (error?.response?.status === 401) {
            HandleAuthError()
        } else {
            console.log(error?.response?.data)
            //alert(error?.response?.data)    
        }
    });
}
